import { Flex, Text } from '@optiaxiom/react';

import HeaderWithTooltip from './HeaderWithTooltip';

type EnabledInChatHeaderProps = {
  enabledCount: number;
};

const EnabledInChatHeader = ({ enabledCount }: EnabledInChatHeaderProps) => (
  <Flex flexDirection="column" gap="2">
    <HeaderWithTooltip
      label="Enabled in Chat"
      info="Toggle to make this tool available for direct messages in Opal chat. Agents triggered from chat can use this tool regardless of this setting. A maximum of 128 tools can be enabled."
    />
    <Text fontSize="xs" color="fg.secondary">
      ({enabledCount} / max 128)
    </Text>
  </Flex>
);

export default EnabledInChatHeader;
